import {
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
} from '@mui/material';
import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

const ICON_WIDTH = '24px'; // 1.5rem;
const ICON_HEIGHT = ICON_WIDTH;

export const SidebarList = styled(List)`
  margin-bottom: 16px !important;
`;

export const SidebarListSubHeader = styled(ListSubheader)`
  padding: 0 12px !important;

  // Override .MuiListSubheader-sticky
  position: unset !important;
`;

export const SidebarListSubHeaderText = styled(ListItemText)`
  padding: 0 !important;
  margin: 0 !important;
  font-weight: calc(${globals.FONT_WEIGHT_STANDARD} * 4); // 400
  font-size: 20px;
  line-height: 40px;
`;

export const AvatarImage = styled(Avatar)`
  width: ${ICON_WIDTH} !important;
  height: ${ICON_HEIGHT} !important;
  img {
    object-fit: contain;
  }
`;

export const ProjectSearchInput = styled(ListItem)`
  padding: 8px 12px !important;
  background-color: unset !important;
  > div {
    width: 100%;
  }

  input {
    width: 100%;
    padding: 0 !important;
    margin-left: 8px;
  }
`;

// Used in TeamsList.tsx
export const SidebarListItemText = styled(ListItemText)`
  margin-left: 8px !important;
  padding: 0 !important;

  overflow: hidden;
  display: flex;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

// Used in TeamsList.tsx
export const SidebarListItemFolderExpand = styled(ListItemButton)`
  // Override material UI to have consistent hovering style
  min-height: 36px;
  height: 36px;
  color: ${THEME.accentText} !important;
  padding-left: 36px !important;

  &:hover {
    color: ${THEME.accent} !important;
    background-color: unset !important;
  }
`;
